import {createTheme} from '@mui/material/styles';
import {useResponsive} from "./Modulo_Responsive/Hooks/useResponsive";


export const theme = createTheme({


    palette: {
        primary: {
            main: "#000000",
            light: '#131313',
        },
        secondary: {
            main: "#DACEC0",
        },
        info: {
            main: "#FED001",
        },
        success: {
            main: "#00FF1E"
        },
        action: {
            main: "#FFF"
        },
        background: {
            default: "#000000",
            paper: "#131313",
        },

    },
    typography: {
        fontFamily: ['Roboto', 'sans-serif'].join(','),
        h1: {
            fontWeight: 300,
            color: "white",
            lineHeight: 1.2,
            fontSize: 42,
            "@media (min-width:600px)": {
                fontSize: 62, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 82, // desktop
            },// puedes definir un color base
        },
        h2: {
            fontWeight: 400,
            lineHeight: 1.2,
            color: "black",
            fontSize: 32, // tamaño base
            "@media (min-width:600px)": {
                fontSize: 42, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 52, // desktop
            },// puedes definir un color base
        },
        t1: {
            fontWeight: 200,
            color: "black",
            fontFamily: ['Roboto', 'sans-serif'].join(','),
            lineHeight: 1.2,
            fontSize: 48, // cell
            "@media (min-width:600px)": {
                fontSize: 50, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 52, // desktop
            },// puedes definir un color base
        },
        t2: {
            fontWeight: 600,
            color: "black",
            fontFamily: ['Roboto', 'sans-serif'].join(','),
            lineHeight: 1.2,
            fontSize: 48, // cell
            "@media (min-width:600px)": {
                fontSize: 50, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 52, // desktop
            },
        },
        h3: {
            fontSize: 32,
            color: "black",
            fontWeight: 600,
            lineHeight: 1.2,
        },
        t3: {
            fontSize: 24,
            color: "black",
            fontFamily: ['Roboto', 'sans-serif'].join(','),
            fontWeight: 400,
            lineHeight: 1.2,
        },
        h4: {
            fontSize: 20,
            color: "black",
            fontWeight: 600,
        },
        t4: {
            fontWeight: 300,
            color: "black",
            fontFamily: ['Roboto', 'sans-serif'].join(','),
            lineHeight: 1.2,
            fontSize: 48, // cell
            "@media (min-width:600px)": {
                fontSize: 50, // tablets
            },
            "@media (min-width:900px)": {
                fontSize: 52, // desktop
            },// puedes definir un color base
        },
        h5: {
            fontSize: 16,
            color: "black",
            fontWeight: 600,
        },
        t5: {
            fontSize: 16,
            color: "#828282",
            fontWeight: 600,
        },
        body1: {
            fontSize: 16,
            fontWeight: 400,
            textAlign: 'left',
            color: "#5A5A5A",
        },
        body2: {
            fontSize: 24,
            fontWeight: 400,
            color: "#5A5A5A",
        },
        allVariants: {
            color: "#303741",

        },
    },
    components: {
        MuiGrid: {
            styleOverrides: {
                root: {
                    transition: "all .2s ease-in-out"
                }
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: "filled",
                size: "medium"
            }
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 6,
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: 6
                }
            }
        },
        MuiButtonBase: {
            variants: [
                {
                    props: {variant: 'efecto'},
                    style: {
                        transition: 'all .1s ease-in-out',
                        borderRadius: 10,
                        '&: hover': {
                            marginTop: -6,
                            boxShadow: "0px 0px 0px 0px rgba(0,0,0,0)",

                        }
                    },
                },


            ],

        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 10,
                    backgroundColor: '#131313',


                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: "contained",
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    fontWeight: 600,
                    paddingLeft: 32,
                    paddingRight: 32,
                    fontSize: 16,
                    textTransform: 'none'


                },
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {

                }
            }
        },



    }


})